import { createRemoteStore } from '@move-frontend/utils';
import { ILoaderAddVehicle } from '../use-cases/addVehicleLoader';
import { PostAddVehicleRequest } from '../../../../shared/api/gateway/types/vehicle';
import { IVehicle } from '../../../../shared/api/gateway/models/Vehicle';

export type AddVehicleStore = ReturnType<typeof createAddVehicleStore>;

export const createAddVehicleStore = (addVehicleLoader: ILoaderAddVehicle) =>
	createRemoteStore<PostAddVehicleRequest, IVehicle>({
		loader: addVehicleLoader,
	});
